export default __webpack_public_path__ + "static/media/uploadIcon.be1897a3.svg";